import { useEffect, useState } from "react";
import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { exchangeToken, meQuery } from "@/api/auth";
import { queryClient } from "@/router";
import { AuthCard } from "@/components/common/AuthCard";

export const Route = createFileRoute("/auth/callback")({
  validateSearch: (s: Record<string, unknown>): { t: string; redirect?: string } => ({
    t: typeof s.t === "string" ? s.t : "",
    ...(typeof s.redirect === "string" ? { redirect: s.redirect } : {}),
  }),
  component: CallbackPage,
});

function CallbackPage() {
  const { t, redirect } = Route.useSearch();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!t) {
      setError("Missing token");
      return;
    }
    // POST (not GET) so mail scanners that prefetch links cannot burn them.
    exchangeToken(t).then(
      (res) => {
        queryClient.setQueryData(meQuery.queryKey, { user: res.user, auth_kind: "session" });
        const target = redirect && redirect.startsWith("/") ? redirect : "/";
        navigate({ to: target, replace: true });
      },
      (err: Error) => setError(err.message),
    );
  }, [t, redirect, navigate]);

  return (
    <AuthCard title={error ? "Sign-in link problem" : "Signing you in..."} subtitle={error ?? "One moment."}>
      {error && (
        <Link to="/login" className="text-sm text-primary underline">
          Request a new link
        </Link>
      )}
    </AuthCard>
  );
}
